module.exports = __webpack_public_path__ + "media/images/checkbox_check-8681b58c857e2d5c3f1af5d2f9e94598.svg";